import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import AuthModal from "./components/ui/AuthModal";
import CartDrawer from "./components/ui/CartDrawer";
import ToastContainer from "./components/ui/ToastContainer";
import SupportChatbotWrapper from "./components/ui/SupportChatbot";


// Wrapper component to access auth context
const AuthModalWrapper = () => {
  const { isAuthModalOpen, closeAuthModal, authModalMode } = useAuth();
  
  return (
    <AuthModal 
      isOpen={isAuthModalOpen} 
      onClose={closeAuthModal} 
      initialMode={authModalMode}
    />
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <NotificationProvider>
            <SupportChatbotWrapper>
              <Routes />
            </SupportChatbotWrapper>
            <AuthModalWrapper />
            <CartDrawer />
            <ToastContainer />
          </NotificationProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
